<template>
  <div class="ballon" :class="'balloon-type-' + type">
  </div>
</template>

<script>
export default {
  name: 'Balloon',
  data () {
    return {
      type: Math.floor(Math.random() * 4) + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ballon {
    position: absolute;
    height: 100%;
    width: 100%;
    background-image: url('./../assets/images/ballon.svg');
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .balloon-type-1 {
    animation-name: mymove1;
    animation-duration: 6s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes mymove1 {
    from {
      transform: translateY(0px);
    }
    to {
      transform: translateY(60px);
    }
  }
  .balloon-type-2 {
    animation-name: mymove2;
    animation-duration: 8s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes mymove2 {
    from {
      transform: translateY(50px);
    }
    to {
      transform: translateY(0px);
    }
  }
  .balloon-type-3 {
    animation-name: mymove3;
    animation-duration: 14s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes mymove3 {
    from {
      transform: translateY(110px);
    }
    to {
      transform: translateY(-10px);
    }
  }
  .balloon-type-4 {
    animation-name: mymove4;
    animation-duration: 9s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes mymove4 {
    from {
      transform: translateY(0px);
    }
    to {
      transform: translateY(90px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Balloon.vue